<template>
  <div class="tw-inline-block tw-cursor-pointer" :style="style">
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="square"
        d="M0 0 L20 20 M0 20 L20 0"
      />
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    size: { type: String, default: "20px" },
    stroke: { type: Number, default: 3 },
  },
  computed: {
    style(): any {
      return { width: this.size, height: this.size };
    },
  },
});
</script>
